import { reactive } from 'vue'

const STORAGE_KEY = 'panel:theme'

function readInitial() {
  return localStorage.getItem(STORAGE_KEY) === 'light' ? 'light' : 'dark'
}

export const themeState = reactive({ value: readInitial() })

// El atributo va en <html> para que los selectores CSS
// `[data-theme='light'] .algo` apliquen a cualquier elemento de la página.
export function setTheme(value) {
  themeState.value = value
  localStorage.setItem(STORAGE_KEY, value)
  document.documentElement.setAttribute('data-theme', value)
}

export function toggleTheme() {
  setTheme(themeState.value === 'dark' ? 'light' : 'dark')
}


// Aplica el tema guardado apenas se carga el módulo, antes de montar
// cualquier componente, para que no haya parpadeo oscuro→claro al entrar.
document.documentElement.setAttribute('data-theme', themeState.value)
